/* eslint-disable camelcase */
import { swoopAPI } from '@/api'

export const loginSSO = data => swoopAPI.post('/api/v1/sso/auth/token', data)
export const changePasswordSSO = data => swoopAPI.post('/api/v1/sso/password/change', data)

// Xero
export const createXeroUser = data => swoopAPI.post('api/v1/sso/xero/create', data)
export const getXeroUserData = (xeroAuthCode, state) => swoopAPI.post(`api/v1/sso/GetXeroUserDetails/${xeroAuthCode}/${state}`)
export const getXeroRedirectLink = state => swoopAPI.get(`api/v1/sso/xero/link/${state}`)
